import React from 'react'
import CreditIcon from '@material-ui/icons/CreditCard'
import EspIcon from '@material-ui/icons/AccountBalanceWallet'
import PersonIcon from '@material-ui/icons/Person'
import SubtitlesIcon from '@material-ui/icons/Subtitles'
import VirIcon from '@material-ui/icons/Input'
import UnkwonIcon from '@material-ui/icons/Help'
import AmericanTableIcon from 'components/AmericanTableIcon'
import FrenchTableIcon from 'components/FrenchTableIcon'
import PoolTableIcon from 'components/PoolTableIcon'
import SnookerTableIcon from 'components/SnookerTableIcon'
import ChineseTableIcon from 'components/ChineseTableIcon'
export const getTableIcon = (type, color = 'inherit') => {
  switch (type) {
    case 'american':
      return <AmericanTableIcon color={color} />
    case 'pool':
      return <PoolTableIcon color={color} />
    case 'snooker':
      return <SnookerTableIcon color={color} />
    case 'carom':
      return <FrenchTableIcon color={color} />
    case 'chinese':
      return <ChineseTableIcon color={color} />
    default:
      return <UnkwonIcon color={color} />
  }
}
export const getPaymentIcon = (type, color = 'inherit') => {
  switch (type) {
    case 'ESP':
      return <EspIcon color={color} />
    case 'CB':
      return <CreditIcon color={color} />
    case 'CHE':
      return <SubtitlesIcon color={color} />
    case 'CRED':
      return <PersonIcon color={color} />
    case 'VIR':
      return <VirIcon color={color} />
    default:
      return <UnkwonIcon color={color} />
  }
}



// WEBPACK FOOTER //
// ./src/utils/iconMatcher.js